export default {
  SET_YEARS: (state, data) => {
    state.years = data;
  },
  SET_YEAR: (state, data) => {
    state.year = data;
  },
};
